export const AUTH_TOKEN = "token";
export const NOTIFICATION_PERMISSION = "notification_permission";
export const FCM_TOKEN = "fcm_token";
export const DEVICE_ID = "device_id";
export const USER_DATA = "user";
export const SAVED_POSTS = "saved_posts";
export const SIDEBAR_COLLAPSED = "sidebar_collapsed";
export const MOBILE_EXTENDED = "mobile_extended";
export const USER_CURRENT_LEVEL = "user_current_level";
